import { Component, Input } from '@angular/core';
import { MessageMaintenance } from '../../models/message-maintenance';
import { TuiCardLarge } from '@taiga-ui/layout';
import { TuiSurface, TuiTitle } from '@taiga-ui/core';
import { TuiIslandDirective } from '@taiga-ui/legacy';

@Component({
  selector: 'app-message-maintenance-card',
  standalone: true,
  imports: [
    TuiIslandDirective,
    TuiCardLarge,
    TuiSurface,
    TuiTitle,
  ],
  templateUrl: './message-maintenance-card.component.html',
  styleUrl: './message-maintenance-card.component.scss'
})
export class MessageMaintenanceCardComponent {
  @Input({ required: true })
  messageMaintenance!: MessageMaintenance;
}
